/*
 * Jira Ticket:
 * Created Date: Thu, 19th Mar 2020, 14:40:41 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React from 'react';
import { TopToolbar, sanitizeListRestProps } from 'react-admin';
import { GetApp } from '@material-ui/icons';
import { ActionButton } from 'Components/Buttons';

const TowerInspectionActions = ({
  currentSort,
  className,
  classes,
  resource,
  filters,
  displayedFilters,
  exporter, // you can hide ExportButton if exporter = (null || false)
  filterValues,
  permanentFilter,
  hasCreate, // you can hide CreateButton if hasCreate = false
  basePath,
  selectedIds,
  onUnselectItems,
  showFilter,
  maxResults,
  total,
  hasList,
  hasShow,
  onClick,
  isAllowedToDownload,
  ...rest
}) => {
  return (
    <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
      <ActionButton
        label={'actions.downloadPDF'}
        variant="text"
        disabled={!isAllowedToDownload}
        onClick={onClick}
        icon={<GetApp />}
      />
    </TopToolbar>
  );
};

TowerInspectionActions.defaultProps = {
  selectedIds: [],
  onUnselectItems: () => null,
};

export default TowerInspectionActions;
